import { useState } from 'react'

import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { CreateThemeForm } from './CreateThemeForm'

export const CreateThemeButton = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger className="bg-primary-20 text-primary-50 border border-primary-50 px-4 py-1.5 rounded-full text-sm">
        Save as new template
      </DialogTrigger>
      <DialogContent ariaLabel="Creating a new document template">
        <DialogHeader>
          <DialogTitle className="text-center">New Template</DialogTitle>
        </DialogHeader>

        <div className="w-full my-6">
          <CreateThemeForm
            onCreate={() => {
              setIsOpen(false)
            }}
            onCancel={() => {
              setIsOpen(false)
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
